import { requireActiveOrg } from '../lib/config'
import { FlightDeskAPI } from '../lib/api'

export async function projectCommand(action: string, _options: Record<string, unknown>) {
  const { config, org } = requireActiveOrg()
  const api = FlightDeskAPI.fromConfig(config, org)

  switch (action) {
    case 'list':
      await listProjects(api)
      break
    default:
      console.error(`Unknown action: ${action}`)
      process.exit(1)
  }
}

async function listProjects(api: FlightDeskAPI) {
  const projects = await api.listProjects()

  if (projects.length === 0) {
    console.log('No projects found.')
    console.log('\nCreate a project at https://app.flightdesk.dev/app/projects/new')
    return
  }

  console.log('Projects:\n')

  // Find the longest name for alignment
  const maxNameLen = Math.max(...projects.map(p => p.name.length), 4)

  for (const project of projects) {
    const name = project.name.padEnd(maxNameLen)
    const repo = project.githubRepo || '(no repo)'
    console.log(`  ${project.id}  ${name}  ${repo}`)
  }

  console.log(`\n${projects.length} project(s)`)
}
